export const CWF_EVENT_ICON_FLY_STORAGE_KEY = "cwf_pendingEventIconFlies";

export type PendingEventIconFly = {
  eventKey: string;
  newProgress: number;
  target: number;
  completed: boolean;
  bonusCoins: number;
};

export function appendPendingEventIconFlies(entries: PendingEventIconFly[]): void {
  if (typeof window === "undefined" || entries.length === 0) return;
  let cur: PendingEventIconFly[] = [];
  try {
    const raw = window.sessionStorage.getItem(CWF_EVENT_ICON_FLY_STORAGE_KEY);
    if (raw) {
      const j = JSON.parse(raw) as unknown;
      if (Array.isArray(j)) cur = j as PendingEventIconFly[];
    }
  } catch {
    cur = [];
  }
  cur.push(...entries);
  try {
    window.sessionStorage.setItem(
      CWF_EVENT_ICON_FLY_STORAGE_KEY,
      JSON.stringify(cur),
    );
  } catch {
    /* noop */
  }
}

export function consumePendingEventIconFlies(): PendingEventIconFly[] {
  if (typeof window === "undefined") return [];
  let raw: string | null = null;
  try {
    raw = window.sessionStorage.getItem(CWF_EVENT_ICON_FLY_STORAGE_KEY);
  } catch {
    return [];
  }
  if (!raw) return [];
  try {
    window.sessionStorage.removeItem(CWF_EVENT_ICON_FLY_STORAGE_KEY);
  } catch {
    /* noop */
  }
  try {
    const j = JSON.parse(raw) as unknown;
    return Array.isArray(j) ? (j as PendingEventIconFly[]) : [];
  } catch {
    return [];
  }
}
